<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-muted mb-0 hover-cursor link" @click="toStockPage">&nbsp;Stock</p>
          <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;Views ID {{ itemCode }}</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="container">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div pr-0">
              <div class="search-table container-fluid">
                <h5 class="card-title mb-4">Stock Detail</h5>
                <div class="row mt-2 align-items-center">
                  <div class="col-lg-11 col-sm mobile-div" v-if="(itemType == 'Laptop' || itemType == 'CPU' || itemType == 'Body' || itemType == 'Motherboard' || itemType == 'WIP' || itemType == 'Monitor')">
                    Warehouse
                    <multiselect v-model="searchPoint" :options="selectWarehouse" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Select Warehouse"></multiselect>
                  </div>
                  <div class="col-lg-11 px-0 col-sm mobile-div" v-if="(itemType == 'Laptop' || itemType == 'CPU' || itemType == 'Body' || itemType == 'Motherboard' || itemType == 'WIP' || itemType == 'Monitor')">
                    <div class="container">
                      <div class="row justify-content-between align-items-center">
                        <div class="col-lg-6 col-sm mobile-div">
                          SN/SC
                          <input type="text" name="stock_code" class="sn-form w-100" v-model="snInput" placeholder="SN/SC">
                        </div>
                        <div class="col-lg-6 col-sm mobile-div">
                          Status
                          <multiselect v-model="statusSelect" :options="selectStatus" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Select Status"></multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-11 px-0 col-sm mobile-div" v-else>
                    <div class="container">
                      <div class="row align-items-center">
                        <div class="col-lg-8 col-sm mobile-div">
                          Warehouse
                          <multiselect v-model="searchPoint" :options="selectWarehouse" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Select Warehouse"></multiselect>
                        </div>
                        <div class="col-lg-4 col-sm mobile-div">
                          Status
                          <multiselect v-model="statusSelect" :options="selectStatus" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Select Status"></multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-1 col-sm mobile-div px-0">
                    <button class="btn btn-primary mt-4 w-100" @click="doSearch">Search</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="col-lg-12 border rounded p-2 my-4">
            <div v-if="!loadingTableTop">
              <div>{{itemType}} - {{itemName}}</div>
              <div class="container">
                <div class="row">
                  <div class="col-lg-3 px-0">Ready Stock: {{countData.qtyReadyStock}}</div>
                  <div class="col-lg-3 px-0">Out Stock: {{countData.qtyOutStock}}</div>
                  <div class="col-lg-3 px-0">Trouble Stock: {{countData.qtyTroubleStock}}</div>
                </div>
              </div>
            </div>
            <div v-else>
              <div colspan="8" class="text-center"><img src="~@/assets/images/load-button.gif" /></div>
            </div>
          </div>
          <div class="col-lg-12 border rounded p-2 my-4">
            <div>Warehouse (Ready Stock)</div>
            <div v-if="loadingTableMid">
              <div colspan="8" class="text-center"><img src="~@/assets/images/load-button.gif" /></div>
            </div>
            <div class="container" v-else>
              <div class="row">
                <div class="col-lg-6 px-0" v-for="(point, index) in countData.warehouse" :key="`pointWh-${index}`">
                  {{point.warehouse}} : {{point.qty}}
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="countData.uom === 'Unit' && countData.qtyReadyStock != 0">
            <div class="col-12">
              <button class="btn btn-primary mt-4 float-right" @click="openModalTrouble()">Trouble</button>
            </div>
          </div>
          <table class="table table-sm table-bordered table-striped table-responsive-sm mt-3" v-if="countData.uom === 'Nos'">
            <thead>
              <tr>
                <th>Unique ID</th>
                <th>Components</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loadingTable === true && totalData == 0">
                <td colspan="8" class="text-center"><img src="~@/assets/images/load-button.gif" /></td>
              </tr>
              <tr v-else-if="loadingTable == false && totalData != 0" v-for="(data,i) in itemDatas" :key="`warehouse-${i}`">
                <td>
                  <div>
                    {{data.warehouse}}
                  </div>
                  <div>
                    Stock Code: {{data.stockCode}} {{statusStock(data.status)}}
                  </div>
                  <div>
                    Serial Number : {{data.serialNumber || '-'}}
                  </div>
                  <div>
                    {{data.supplier}}
                  </div>
                </td>
                <td>
                  <div v-for="(item,i) in data.bomItem" :key="`${item.itemName}-${i}`">
                    <div v-for="index in item.itemQty" :key="`${item.itemName}-${i}-${index}`">
                      {{item.itemName}}
                    </div>
                  </div>
                </td>
                <td class="text-center text-primary" style="cursor: pointer" @click="toDetailStock(data.serialNumber)">Detail</td>
              </tr>
              <tr v-if="totalData == 0 && loadingTable == false">
                <td colspan="8" class="text-center">Data Not Available</td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="col-lg-12 px-0">
            <div class="container" v-if="itemType !== 'Laptop' && itemType !== 'CPU' && itemType !== 'Body' && itemType !== 'Motherboard'">
              <div class="row justify-content-end">
                <div class="col-lg-1 col-sm mobile-div px-0">
                  <button class="btn btn-primary w-100">Trouble</button>
                </div>
              </div>
            </div>
          </div> -->
          <div id="wrapperr" v-if="itemType == 'Laptop' || itemType == 'CPU' || itemType == 'Body' || itemType == 'Motherboard' || itemType == 'WIP' || itemType == 'Monitor'">
            <div id="c1" class="d-flex">
              <div style="margin-right: 10px;">
                <select class="form-control form-control-sm" v-model="itemPerPage" @change="changePage(page, itemPerPage)">
                  <option value="10">10</option>
                  <option value="40">40</option>
                  <option value="80">80</option>
                </select>
              </div>
              <div class="alignLeft total-data">
                Total Data {{ totalData }}
              </div>
            </div>
            <div id="c2">
              <div class="pagination p8 alignRight">
                <ul>
                  <a class="is-active link" @click="changePage(+page -1, itemPerPage)" v-if="page != 1">
                    <li>{{'<'}}</li> 
                  </a> 
                  <a class="page">
                    <li>{{ page }} of {{ totalPage }} page</li>
                  </a>
                  <a class="is-active link" @click="changePage(+page +1, itemPerPage)" v-if="page != totalPage">
                    <li>></li>
                  </a>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalTrouble" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <!-- <h4 class="modal-title">Trouble</h4> -->
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <h5>Set to trouble {{itemName}}</h5>
              <div class="row mt-3">
                <div class="col-3 mt-auto">
                  <label>Warehouse From</label>
                </div>
                <div class="col-9">
                  <multiselect v-model="warehouseFrom" :options="selectWarehouseFrom" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Warehouse" label="warehouse"></multiselect>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-3 mt-auto">
                  <label>Warehouse To</label>
                </div>
                <div class="col-9">
                  <multiselect v-model="warehouseTo" :options="selectWarehouseTo" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Warehouse"></multiselect>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-3 mt-auto">
                  <label>Qty</label>
                </div>
                <div class="col-9">
                  <input type="text" name="" v-model="qty" class="form-control" @keypress="isNumber($event)">
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" :disabled="loadingSave" @click="setTrouble()"><img src="~@/assets/images/2.gif" style="height: 18px;" v-if="loadingSave" />Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import SideBar from '../SideBar.vue';
export default {
  name: 'StockViewNew',
  components: {
    SideBar,
    Multiselect
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
      qty: "",
      selectWarehouseFrom: [],
      selectWarehouseTo: [],
      warehouseFrom: "",
      warehouseTo: "",
      admin: '',
      adminId: '',
      permission: [],
      itemCode: '',
      itemType: '',
      itemName: '',
      itemDatas: [],
      countData: { itemName: '', qtyReadyStock: 0, qtyOutStock: 0, qtyTroubleStock: 0 },
      searchPoint: '',
      statusSelect: '',
      selectWarehouse: [],
      selectStatus: ['All', 'Ready Stock', 'Out Stock', 'Trouble Stock'],
      snInput: '',
      page: 1,
      totalPage: 1,
      ItemPerPage: 10,
      totalData: 0,
      loadingTableTop: false,
      loadingTableMid: false,
      loadingTable: false,
      loadingSave: false,
    }
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getWarehouseByStatus(status) {
      this.$http.get(process.env.GET_WAREHOUSE_BY_STATUS + "/" + status, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            if (status == "Trouble Stock") {
              this.selectWarehouseTo = res.data.content
            }
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    setTrouble() {
      if (this.warehouseFrom.warehouse == "" || this.warehouseTo == "" || this.qty == "" || this.qty == "0") {
        swal("Sorry", "Semua field harus diisi!", "error", {
          button: "Ok",
        });
      } else if (this.qty > this.warehouseFrom.maxQty) {
        swal("Sorry", "Quantity yang tersedia " + this.warehouseFrom.maxQty, "error", {
          button: "Ok",
        });
      } else {
        self = this
        this.loadingSave = true
        this.$http.post(process.env.SET_STOCK_TO_TROUBLE, {
            fromWarehouse: this.warehouseFrom.warehouse,
            toWarehouse: this.warehouseTo,
            itemCode: this.itemCode !== null ? this.itemCode.replace(this.spaceRegex, ' ') : this.itemCode,
            itemName: this.itemName !== null ? this.itemName.replace(this.spaceRegex, ' ') : this.itemName,
            itemGroup: this.itemType !== null ? this.itemType.replace(this.spaceRegex, ' ') : this.itemType,
            qty: this.qty
          }, {
            headers: {
              'Asani-Token': localStorage.getItem('jwt')
            }
          })
          .then(res => {
            if (res.data.status == 200) {
              this.loadingSave = false
              $("#modalTrouble").modal("hide");
              swal("Berhasil", "Product has been updated to trouble stock", "success", {
                button: "Ok",
              }).then((value) => {
                this.getWarehouseCount()
                this.getSnData()
                this.getWarehouse()
                this.warehouseFrom = ""
                this.warehouseTo = ""
                this.qty = ""
              })
            } else {
              this.loadingSave = false
              swal("Error", res.data.message, "error", {
                button: "Ok",
              })
            }
          })
          .catch(error => {
            self.loadingSave = false
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          });
      }
    },
    openModalTrouble() {
      $("#modalTrouble").modal("show");
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toPage(e) {
      this.$router.push(e)
    },
    toStockPage() {
      this.$router.push({
        path: '/stock/product',
        query: {
          page: 1,
          itemPerPage: 10,
          type: '',
          name: ''
        }
      })
    },
    toDetailStock(sn) {
      this.$router.push('/stockItem/' + sn)
    },
    searchSCSN() {
      const scsn = this.snInput !== null ? this.snInput.replace(this.spaceRegex, ' ') : this.snInput
      this.$http.get(process.env.GET_SEARCH_SN + `/${scsn}`, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.$router.push({
              path: '/stockItem/' + res.data.content.serialNumber
            })
          } else {
            swal('Error', 'SN/SC tidak ditemukan.', 'error')
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    doSearch() {
      if (this.snInput.length == 0) {
        this.$router.push({
          path: '/stock/views/' + this.itemCode,
          query: {
            page: 1,
            itemPerPage: 10,
            status: this.statusSelect,
            warehouse: this.searchPoint
          }
        })
      } else {
        this.searchSCSN()
      }

    },
    changePage(page, itemPerPage) {
      this.$router.push({
        path: '/stock/views/' + this.itemCode,
        query: {
          page,
          itemPerPage,
          status: this.statusSelect,
          warehouse: this.searchPoint
        }
      })
    },
    getWarehouse() {
      this.$http.get(process.env.GET_WAREHOUSE_ERP, {
          timeout: 300 * 1000,
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          this.selectWarehouse.push('All')
          for (let i in res.data.content) {
            this.selectWarehouse.push(res.data.content[i])
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
            this.handleLogout()
            }
          })
        })
    },
    getWarehouseCount() {
      this.loadingTableTop = true
      this.loadingTableMid = true
      const sentItemCode = this.itemCode !== null ? this.itemCode.replace(this.spaceRegex, ' ') : this.itemCode
      this.$http.get(process.env.GET_WAREHOUSE_COUNT + `/${sentItemCode}`, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          
          this.countData = res.data.data
          this.itemType = res.data.data.itemGroup
          this.itemName = res.data.data.itemName.indexOf("-") > -1 ? 
            res.data.data.itemName.substring(res.data.data.itemName.indexOf("-") + 2) : res.data.data.itemName
          if (this.countData.qtyReadyStock != 0) {
            this.getWarehouseByStatus("Trouble Stock");
          }
          this.selectWarehouseFrom = []
          for (var i = 0; i < this.countData.warehouse.length; i++) {
            if (this.countData.warehouse[i].qty != 0) {
              this.selectWarehouseFrom.push({
                warehouse: this.countData.warehouse[i].warehouse,
                maxQty: this.countData.warehouse[i].qty
              });
            }
          }
          this.loadingTableTop = false
          this.loadingTableMid = false
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getSnData() {
      this.loadingTable = true
      let warehouse = ''
      if (this.searchPoint !== 'All') {
        warehouse = this.searchPoint
      }
      const itemCode = this.itemCode !== null ? this.itemCode.replace(this.spaceRegex, ' ') : this.itemCode
      this.$http.post(process.env.GET_STOCK_DETAIL_ERP, {
          itemCode: parseInt(itemCode),
          page: parseInt(this.page),
          itemPerPage: parseInt(this.itemPerPage),
          warehouse: warehouse,
          status: this.statusSelect
        }, {
          timeout: 300 * 1000,
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          this.totalData = res.data.content.totalData
          this.totalPage = res.data.content.totalPage
          this.itemDatas = res.data.content.data
          this.loadingTable = false
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    statusStock(val) {
      return `(${val})`
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewEmployee == false) {
        this.$router.push('/')
      }
    },
  },
  created() {
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.itemCode = this.$route.params.id
    this.page = this.$route.query.page
    this.itemPerPage = this.$route.query.itemPerPage
    this.statusSelect = this.$route.query.status
    this.searchPoint = this.$route.query.warehouse
    this.cekLogin()
    this.cekPermission()
    this.getWarehouseCount()
    this.getSnData()
    this.getWarehouse()
  }
}
</script>

<style scoped>
.sn-form {
  display: block;
  height: calc(1.5em + 0.8rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgb(232, 232, 232);
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.edit-lessor-title {
  width: 151px;
  margin: auto;
}

.btn-outline-right {
  border: 1px solid black;
  border-left: none;
}

.btn-outline-left {
  border: 1px solid black;
  border-right: none;
}

.two-button {
  display: flex;
  box-shadow: 2px;
  width: 100%;
}

.block {
  display: block;
  width: 100%;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  border-radius: 0px;
}

.input-group-addon {
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  margin: 0px 0px 0px 0px;
  height: fit-content;
}

.label-addon-rp {
  margin: 4px 0px;
}

.cekbox {
  margin-top: 6px;
  margin-right: 5px;
}

.roles-sub-menu {
  /*display: flex;*/
  margin-left: 15px;
}

.one-line {
  display: flex;
  margin: 7px 0px;
}

.border-red {
  border-color: red;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.pagg {
  display: inline-flex;
  overflow: auto;
}

.total-data {
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}

.active {
  color: #2797FB;
}

.right-dropdown {
  margin-left: 7px;
}

.account-div {
  margin: 2px 2px;
}

.right-arrow {
  margin-left: auto;
}

.brand-logo {
  width: 120px;
}

.menu-title {
  margin-left: 1.125rem;
}

.menu-title-order {
  margin-left: 1.95rem;
}

.menu-title-payment {
  margin-left: 1.525rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}

li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}

li a.active {
  background-color: #4CAF50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}

.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}

.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}

.nav-side-menu .toggle-btn {
  display: none;
}

.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}

.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}

.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}

.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}

.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}

.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}

.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}

.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }

  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }

  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}

@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}

@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}

.form-control-md {
  display: block;
  width: 41rem;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/Stock/StockViewPageNew.vue